import React from "react";
import { Dot, Logo, QuoteWrapper, SideView } from "../styles";
import HeroBanner from "assets/images/building.jpeg";
import NeoInsuranceLogo from "assets/svgs/neoInsuranceLogoWhite_risk.svg";
import DotPattern from "assets/svgs/dot_pattern.svg";
import { Ptag } from "components/core";

function SideBanner() {
  return (
    <aside role="hidden" style={{ height: "100%"}}>
      <SideView bg={HeroBanner}>
        <Logo src={NeoInsuranceLogo} alt="Neo Insurance" />
        <QuoteWrapper>
          <Ptag
            fontFamily="Merriweather"
            fontSize="36px"
            fontWeight="400"
            letterHeight="normal"
            color="white"
          >
            Simplify Benefits,
          </Ptag>
          <Ptag
            fontFamily="Merriweather"
            fontSize="36px"
            letterHeight="normal"
            fontWeight="400"
            color="#EFD287"
          >
            Elevate Employee Experience
          </Ptag>
        </QuoteWrapper>
        <Dot src={DotPattern} alt="Dot Pattern" />
      </SideView>
    </aside>
  );
}

export default SideBanner;
